import { IDeviceEventOutput } from './device-event-output.interface';
import { IDeviceIdentificationObject } from './device-identification-object.interface';
import { IPlatformOutputDto } from './platform-output-dto.interface';

export interface IDeviceOutputDto {
    id: number;
    externalId?: string;
    externalIdSource: string;
    organizationId: string;
    platformId?: number;
    platform?: IPlatformOutputDto;
    name?: string;
    code?: string;
    enabled: boolean;
    identification?: IDeviceIdentificationObject;
    events?: IDeviceEventOutput[];
}
